import { ServiceRecords } from '@/service/records/serviceRecords'

const recordsService = new ServiceRecords()

export default {
  namespaced: true,
  state: {
    loading: false,
    history: [],
    historySelected: {},
    customer_id: null,
    meta: {
      page: 1,
      pageSize: 5,
      total: 0,
    },
  },
  mutations: {
    setHistory(state, { history, meta }) {
      state.history = history
      state.meta = meta
    },
    setHistorySelected(state, history) {
      state.historySelected = history
    },
    setCustomerId(state, customerId) {
      state.customer_id = customerId
    },
    setLoading(state, loading) {
      state.loading = loading
    },
  },

  getters: {
    getHistory(state) {
      return state.history
    },
    getHistorySelected(state) {
      return state.historySelected
    },
    getMeta(state) {
      return state.meta
    },
  },

  actions: {
    async fetchHistory({ commit, state }, query = {}) {
      commit('setLoading', true)
      try {
        const response = await recordsService.fetchHistoryPatient(state.customer_id, query)

        commit('setHistory', { history: response.data, meta: response.meta })

        commit('setLoading', false)
      } catch (error) {
        console.error('Erro ao buscar todos os registros:', error)
        commit('setLoading', false)
        throw error
      }
    },
  },
}
